import { FooterHelp } from '@shopify/polaris'
import React from 'react'

const Footer = () => {
  return (
        <FooterHelp>
               Copyright 2022 InfoShore Technology Solutions LLP. All right reserved.
        </FooterHelp>
  )
}

export default Footer